module.exports = __webpack_public_path__ + "img/17.55d324c7.png";